import React, { Component } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";

class FrDominicValanmanalPage extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.observer = null;
    this.state = { loadVideo: false };
  }

  componentDidMount() {
    // Use IntersectionObserver to start loading when in/near viewport
    if ("IntersectionObserver" in window && this.containerRef.current) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.setState({ loadVideo: true });
              if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
              }
            }
          });
        },
        { root: null, rootMargin: "200px", threshold: 0.1 }
      );
      this.observer.observe(this.containerRef.current);
    } else {
      // Fallback: load immediately if IntersectionObserver not supported
      this.setState({ loadVideo: true });
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  handleManualLoad = () => {
    this.setState({ loadVideo: true });
  };

  render() {
    const publicUrl = process.env.PUBLIC_URL || "";
    const mp4 = `${publicUrl}/video/_Grace Anointing promo.mp4`;
    const webm = mp4.replace(".mp4", ".webm");
    const poster = `${publicUrl}/images/FrDominic1196x1536.jpg`;

    return (
      <React.Fragment>
        <div className="container-fluid position-relative p-0">
          <MenuBar />
          <div className="video-container" ref={this.containerRef}>
            {/* Placeholder shown until video is loaded */}
            {!this.state.loadVideo && (
              <div className="video-placeholder" style={{ position: "relative" }}>
                <img src={poster} alt="video poster" style={{ width: "100%", height: "auto" }} />
                <button
                  type="button"
                  onClick={this.handleManualLoad}
                  style={{
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    padding: "12px 18px",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                >
                  Load video
                </button>
              </div>
            )}

            {/* Only render <video> (and sources) when loadVideo is true */}
            {this.state.loadVideo && (
              <video
                id="videoid"
                className="video"
                loop
                // autoplay with sound is usually blocked; mute if you need autoplay
                muted
                playsInline
                controls
                preload="none" // important: don't preload until we attach sources
                onError={() => console.error("Error loading video")}
                poster={poster}
              >
                <source src={mp4} type="video/mp4" />
                <source src={webm} type="video/webm" />
                Your browser does not support the video tag.
              </video>
            )}

            <div className="banner-heading text-center wow fadeInDown">
              <h1 className="text-white">Fr. Dominic Valanmanal</h1>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="container mt-4">
          {/* Image and Text Section */}
          <div className="row mb-5 align-items-top">
            <div className="col-md-6 text-center" style={{ height: "100%" }}>
              <img
                className="shadow-sm"
                src={`${process.env.PUBLIC_URL}/images/FrDominic1196x1536.jpg`}
                alt="Father Dominic Valanmanal"
              />
            </div>
            <div className="col-md-6">
              <p>
                Father Dominic Valanmanal founded the Marian Retreat Centre, a
                charismatic renewal retreat center under the Catholic Diocese of
                Kanjirapally, India, in 2009. He currently serves as its
                director. Father Dominic is uniquely chosen and anointed for the
                ministry of the Word, Healing, Exorcism, and Deliverance. His
                ministry is highly sought after both in India and abroad, with
                his anointed service in Exorcism and Deliverance, through
                preaching the Word, reaching 96 countries. In 1995, during a
                journey to his spiritual guide, Father Dominic experienced a
                profound encounter with God, where the Holy Spirit spoke to him
                through 1 Corinthians 2:2. Following this revelation, he
                wholeheartedly embraced an ascetic life, dedicating himself
                entirely to the Word of God. The Holy Spirit then anointed him
                with the Gift of the Word, and through deep meditation and
                detachment from worldly pleasures, he received the Gifts of
                Exorcism and Deliverance, leading to numerous healings and
                manifestations throughout his ministry. Despite its remote
                location, the Marian Retreat Centre has attracted hundreds of
                thousands of people who have attended his deliverance and
                healing grace anointing retreats. Additionally, more than five
                thousand priests and approximately fifteen thousand consecrated
                individuals have participated in deliverance retreats at the
                Centre. Rev. Father Dominic’s Deliverance Ministry emphasizes Jesus
                as the Word of God, highlighting holiness, an ascetic lifestyle,
                the Eucharist as the center of life, and the unceasing
                intercession of Mother Mary. Over the years, many young people
                have been inspired to follow his ascetic lifestyle in pursuit of
                the anointing of the Word. These individuals commit to a year of
                radical detachment and study of the Word, after which they
                embark on missions of grace for deliverance and preaching. To
                date, more than 150 young individuals have completed this
                missionary formation. Throughout his 25 years of priesthood,
                Rev. Father Dominic has been miraculously used for preaching and
                deliverance ministry within the global Catholic Church. During
                his sermons, Adoration, Holy Eucharist, and worship sessions,
                manifestations of deliverance and healing frequently occur by
                the grace of God, echoing the Biblical promise found in Matthew
                8:16. Following divine guidance and orders from the Holy Spirit,
                Father Dominic has expanded his ministry to other countries. Every
                month, multiple deliverance prayers in the form of retreats and
                conventions are held across Europe, the Americas, Middle East,
                and Australia. Despite the physical hardships and health issues
                caused by constant travel and his ascetic lifestyle, he
                continues to provide deliverance prayers to those in need.
              </p>
            </div>

            {/* Additional Information */}

            <div className="col-md-12">
              <p></p>
            </div>
          </div>
        </div>

        <FooterPanel />
      </React.Fragment>
    );
  }
}

export default FrDominicValanmanalPage;
